import { useTheme } from "next-themes"
import { Toaster as Sonner, toast } from "sonner"
import { isValidElement } from "react"
import { toText } from "@/lib/apiError"

// Session 68 — harden every toast against non-string messages. A FastAPI
// 422 returns `detail` as an array of objects; `toast.error(detail)` then
// rendered an object as a React child and crashed the whole screen
// ("Minified React error #31" on /Kitchen in production). Coerce the
// message (and `description`) to text once, here, for every caller —
// React elements and functions are passed through untouched.
const coerce = (value, fallback) => {
  if (value === null || value === undefined) return fallback;
  if (typeof value === "string" || typeof value === "number" || isValidElement(value) || typeof value === "function") return value;
  return toText(value, fallback);
};
const coerceOpts = (opts) => {
  if (!opts || typeof opts !== "object") return opts;
  if (opts.description === undefined || opts.description === null) return opts;
  return { ...opts, description: coerce(opts.description, "") };
};
if (!toast.__nfcsSafe) {
  for (const kind of ["error", "success", "info", "warning", "message", "loading"]) {
    const original = toast[kind];
    if (typeof original !== "function") continue;
    toast[kind] = (message, opts) => original(coerce(message, kind === "error" ? "Something went wrong — please try again." : ""), coerceOpts(opts));
  }
  toast.__nfcsSafe = true;
}

const Toaster = ({
  ...props
}) => {
  const { theme = "system" } = useTheme()

  return (
    <Sonner
      theme={theme}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />
  );
}

export { Toaster, toast }
